<template>
  <v-card>
    <button
      class="close-btn"
      @click="$emit('input', false)"
    >
      <v-icon>mdi-close</v-icon>
    </button>
    <v-form
      v-model="ok"
      class="pt-4 px-5"
    >
      <h4>パスワード変更</h4>
      <v-container>
        <v-layout
          pt-2
          px-5
          column
        >
          <v-flex xs8>
            <v-text-field
              v-model.trim="newPass1"
              label="新しいパスワード"
              :append-icon="visibility.newPass1 ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required, rules.min]"
              :type="visibility.newPass1 ? 'text' : 'password'"
              hint="8文字以上で入力してください。"
              @click:append="visibility.newPass1 = !visibility.newPass1"
              @input="resetConformPassword"
            />
            <v-text-field
              v-model.trim="newPass2"
              label="新しいパスワード（確認用）"
              :append-icon="visibility.newPass2 ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required, rules.min, rules.match]"
              :type="visibility.newPass2 ? 'text' : 'password'"
              @click:append="visibility.newPass2 = !visibility.newPass2"
            />
          </v-flex>
          <v-flex
            xs8
            align-self-end
          >
            <v-btn
              color="success"
              :loading="loading"
              :disabled="!ok"
              @click="updatePassword"
            >
              変更
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import { api } from '@/api'
export default {
  name: 'PasswordUpdate',
  props: {
    userId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      ok: false,
      newPass1: '',
      newPass2: '',
      loading: false,
      visibility: {
        newPass1: false,
        newPass2: false
      },
      rules: {
        required: value => !!value || '入力必須項目です。',
        min: v => v.length >= 8 || '8文字以上で入力してください。',
        match: v => v === this.newPass1 || '新しいパスワードとマッチしません。'
      }
    }
  },
  methods: {
    async updatePassword () {
      this.loading = true
      try {
        await api.setUserPassword({ newPassword: this.newPass1 }, this.userId)
        this.$emit('input', false)
        this.$store.commit('app/setGlobalSnackBarText', 'パスワードを更新しました。')
      } finally {
        this.loading = false
      }
    },
    resetConformPassword (e) {
      if (this.newPass2 && e !== this.newPass2) {
        this.newPass2 = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .close-btn {
    position: absolute;
    top: 15px;
    right: 20px;
    transition: transform 0.2s;
    outline: none;
  }
  .close-btn:hover {
    transform: scale(1.15);
  }
</style>
